module.exports = __webpack_public_path__ + "static/media/book.caad6812.png";